import { atom, selector, selectorFamily, useSetRecoilState } from "recoil"
import { ListingCategory, useFindAllCategoriesQuery } from "../generated/graphql"

export const categoryAtom = atom({
  key: "categoryAtom",
  default: {
    total: 0,
    loading: false,
    categories: [] as ListingCategory[],
    allCategories: [] as ListingCategory[],
  },
})

export const categoriesSelector = selector({
  key: "categoriesSelector",
  get: ({ get }) =>
    get(categoryAtom).allCategories.map((category) => ({
      value: category.id,
      label: category.name,
      icon: category.icon,
    })),
})

export const categoryByIdSelector = selectorFamily({
  key: "categoryByIdSelector",
  get:
    (id) =>
    ({ get }) =>
      get(categoryAtom).allCategories.find((o) => o.id === id) ?? ({} as ListingCategory),
})

export const useFetchCategories = () => {
  const setCategoriesState = useSetRecoilState(categoryAtom)
  useFindAllCategoriesQuery({
    onCompleted: ({ findManyCategory }) => {
      const categories = findManyCategory?.categories ?? ([] as any)

      setCategoriesState({
        total: findManyCategory?.total ?? 0,
        categories: categories,
        allCategories: findManyCategory?.categories ?? ([] as any),
        loading: false,
      })
    },
  })
}
